export default {"src":"/_next/static/media/poc-cloud-white.81d21040.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};